export default {
  init() {
    // JavaScript to be fired on the offline data template
    $('.magazine-slider').slick({
      dots: false,
      prevArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
      nextArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
      infinite: true,
      speed: 300,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateOfflineData.js